<navigation-phone class="navigation border-box fl-fixed" [selectedId]="selectedPage">
	<button
		class="navigation-item flex fl-ai-c fl-jc-c"
		[navigationElement]="keys.DASHBOARD"
		(click)="navigateTo(keys.DASHBOARD)"
	>
		<i [ngClass]="navigationIcon(keys.DASHBOARD)"></i>
	</button>

	<button
		class="navigation-item flex fl-ai-c fl-jc-c"
		[navigationElement]="keys.CHAT_AI"
		(click)="navigateTo(keys.CHAT_AI)"
	>
		<i [ngClass]="navigationIcon(keys.CHAT_AI)"></i>
	</button>

	<button
		class="navigation-item flex fl-ai-c fl-jc-c"
		[navigationElement]="keys.CREATE_NODE"
		(click)="navigateTo(keys.CREATE_NODE)"
	>
		<i [ngClass]="navigationIcon(keys.CREATE_NODE)"></i>
	</button>

	<button
		class="navigation-item flex fl-ai-c fl-jc-c"
		[navigationElement]="keys.SEARCH"
		(click)="navigateTo(keys.SEARCH)"
	>
		<i [ngClass]="navigationIcon(keys.SEARCH)"></i>
	</button>

	<button
		class="navigation-item flex fl-ai-c fl-jc-c"
		[navigationElement]="keys.PROFILE"
		(click)="navigateTo(keys.PROFILE)"
	>
		<reach-user-thumbnail
			style="
				width: calc(var(--fs-icon) + calc(var(--spacing) * 0.5));
				height: calc(var(--fs-icon) + calc(var(--spacing) * 0.5));
			"
			class="br-circle bordered"
			[useInitials]="true"
			[user]="user$ | async"
		>
			<i class="icon-contact"></i>
		</reach-user-thumbnail>
	</button>
</navigation-phone>

@if (loading) {
	<div
		class="loading-indicator pos-abs pos-t-0 pos-l-0 w-100 h-100 fl fl-ai-c fl-jc-c bg-backdrop"
		style="z-index: 11"
	>
		<reach-logo-loader [spinning]="true"></reach-logo-loader>
	</div>
}
